import { Icon, IconProps } from "../Icon";

const Mint = (props: IconProps) => (
  <Icon {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.2426 11.7574L16 1L11.7574 11.7574L1 16L11.7574 20.2426L16 31L20.2426 20.2426L31 16L20.2426 11.7574ZM25.5488 16L18.7008 13.2992L16 6.45121L13.2992 13.2992L6.45121 16L13.2992 18.7008L16 25.5488L18.7008 18.7008L25.5488 16Z"
      fill="currentColor"
    />
  </Icon>
);

export default Mint;
